import { useState, memo } from "react";
import { formatPhoneNumber, convertTo12Hour } from "../../../../functions";
import { cancelBtnSvg, ghostSvg, phoneSvg, phoneMissedSvg } from "svg";
import { dateToShortString, friendlyDateTime } from "dateUtils";
import { useMobile } from "context/MobileContext";
import CustomerHistory from "./CustomerHistory";

function ReservationImpl(props) {
  const [isOpen, setOpen] = useState(false);
  const { res, setResModal, handleBtnClick, onContextMenu } = props;
  const { phone } = useMobile();
  const isLocal = typeof window !== "undefined" && window.location.hostname === "localhost";

  function arrivedTime() {
    const displayTime = res.state === "walkin" ? res.time : res.arrivedTime;
    return (
      <div
        className="res-arrived-time"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginBlock: "auto",
          height: "fit-content",
        }}
      >
        <div className="res-name"> Arrived </div>
        <span className="res-secondary"> {convertTo12Hour(displayTime)} </span>
      </div>
    );
  }

  function completeButton() {
    return (
      <button
        className="res-btn"
        onClick={(event) => {
          event.stopPropagation();
          handleBtnClick(res, "arrived");
        }}
      >
        <svg
          width="24"
          height="24"
          viewBox="-.5 -2 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 6L9 17L4 12"
            stroke="#ffffff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    );
  }

  function undoButton() {
    return (
      <button
        className="res-btn res-cancel res-btn-smaller"
        onClick={() => {
          setOpen(false);
          handleBtnClick(res, "upcoming");
        }}
      >
        <svg
          width="24"
          height="24"
          viewBox="-.5 -2 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 4V10H7"
            stroke="#ffffff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.51 15C4.15839 16.8404 5.38734 18.4202 7.01166 19.5014C8.63598 20.5826 10.5677 21.1066 12.5157 20.9945C14.4637 20.8824 16.3226 20.1402 17.8121 18.8798C19.3017 17.6193 20.3413 15.909 20.7742 14.0064C21.2072 12.1037 21.0101 10.112 20.2126 8.3311C19.4152 6.55025 18.0605 5.0768 16.3528 4.13277C14.6451 3.18874 12.6769 2.82527 10.7447 3.09712C8.81245 3.36897 7.02091 4.26142 5.64 5.64L1 10"
            stroke="#ffffff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    );
  }

  function noShowButton() {
    return (
      <button
        className="res-btn res-noshow res-btn-smaller"
        onClick={() => {
          setOpen(false);
          handleBtnClick(res, "noshow");
        }}
      >
        {ghostSvg()}
      </button>
    );
  }

  function cancelButton() {
    return (
      <button
        className="res-btn res-cancel res-btn-smaller"
        onClick={() => {
          setOpen(false);
          handleBtnClick(res, "cancel");
        }}
      >
        {cancelBtnSvg()}
      </button>
    );
  }

  function noteSymbol() {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 15C3 15.5304 3.21071 16.0391 3.58579 16.4142C3.96086 16.7893 4.46957 17 5 17H17L21 21V5C21 4.46957 20.7893 3.96086 20.4142 3.58579C20.0391 3.21071 19.5304 3 19 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V15Z"
          stroke="#ffffff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  const stateMap = {
    noshow: ghostSvg(),
    cancel: cancelBtnSvg(),
  };

  const resTop = () => {
    return (
      <button
        type="button"
        className={`res
        ${res.selfMade && "res-selfmade"}
        ${(res.state === "arrived" || res.state === "walkin") && "res-arrived"} res-${isOpen}`}
        key={res._id}
        onClick={() => setOpen(!isOpen)}
        onContextMenu={(e) => {
          if (!isLocal || !onContextMenu) return;
          e.preventDefault();
          onContextMenu(e, res);
        }}
      >
        <div className="res-row">
          <div className="res-left">
            <div
              className={`res-amount`}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                alignContent: "center",
                marginBlock: "auto",
                height: "fit-content",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setResModal(res);
              }}
            >
              {res.numGuests}
            </div>
            <div className="res-left-text">
              <div className="res-time">
                {res.state === "walkin" ? "Walk-in" : convertTo12Hour(res.time)}
              </div>
              <div className="res-name">{res.name}</div>
            </div>
          </div>
          <div className="res-right-side">
            <div className="res-btns">
              {res.state !== "cancel" &&
                res.state !== "noshow" &&
                res.state !== "walkin" &&
                res.notes &&
                noteSymbol()}
              {res.state !== "cancel" &&
                res.state !== "noshow" &&
                res.state !== "walkin" &&
                res.sendText &&
                res.resTextSent !== undefined &&
                !res.resTextSent &&
                phoneMissedSvg()}
              {res.state !== "cancel" && res.state !== "noshow" && res.state !== "walkin" && res.isConfirmed && (
                <span className="res-badge-confirmed">
                  {phone ? "C" : "Confirmed"}
                </span>
              )}
              {res.state !== "cancel" && res.state !== "noshow" && res.state !== "walkin" && !res.isConfirmed && res.confirmTextSentAt && (
                <span className="res-badge-pending">
                  {phone ? "P" : "Pending"}
                </span>
              )}
              {res.state === "upcoming" && completeButton()}
              {(res.state === "arrived" || res.state === "walkin") && arrivedTime()}
              {(res.state === "cancel" || res.state === "noshow") && (
                <button className="res-btn res-btn-mock">
                  {" "}
                  {stateMap[res.state]}{" "}
                </button>
              )}
            </div>
          </div>
        </div>
      </button>
    );
  };

  const logs = (
    res.state === "walkin"
      ? [...res.logs]
      : [
          {
            time: res.dateMade,
            user: res.user || "Customer",
            newState: [{ key: "state", value: "created" }],
            ...(res.sendText && res.resTextSent !== undefined && { textStatus: res.resTextSent ? "sent" : "failed" }),
          },
          ...res.logs,
        ]
  ).sort((a, b) => new Date(a.time) - new Date(b.time));

  const logValueMap = {
    created: {
      value: "Reservation created",
      className: "green-log",
    },
    noshow: {
      value: "Marked as no show",
      className: "res-secondary res-log-secondary",
    },
    cancel: {
      value: "Reservation canceled",
      className: "red-log",
    },
    arrived: {
      value: "Customer checked in",
      className: "green-log",
    },
    upcoming: {
      value: "Reverted to upcoming",
      className: "res-secondary res-log-secondary",
    },
    confirmed: {
      value: "Reservation confirmed",
      className: "green-log",
    },
    seated: {
      value: "Customer seated",
      className: "green-log",
    },
  };

  const actionValueMap = {
    confirmationSent: {
      value: "Confirmation text sent",
      className: "green-log",
    },
    waitlistAdded: {
      value: "Added to waitlist",
      className: "res-secondary res-log-secondary",
    },
    tableReadyTextSent: {
      value: "Sent table ready text",
      className: "green-log",
    },
    customerConfirmed: {
      value: "Customer confirmed",
      className: "green-log",
    },
    textDeliveryFailed: {
      value: "Text could not be delivered",
      className: "red-log",
    },
  };

  const renderLog = (log, index) => {
    const renderTextStatus = () => {
      if (!log.textStatus) return null;
      const isSent = log.textStatus === "sent";
      const label = isSent
        ? "Text sent"
        : log.textStatus === "opted-out"
        ? "Customer opted out of texts"
        : "Text failed";
      return (
        <>
          <div className={isSent ? "phone-log green-log" : "phone-log red-log"}>
            {isSent ? phoneSvg() : phoneMissedSvg()}
          </div>
          <span>{label}</span>
        </>
      );
    };

    const renderSingleLogChange = (index) => {
      const change = log.newState[index];
      const prev = log.oldState && log.oldState[index];
      if (prev) {
        const isDateKey = change.key !== "state" && change.key !== "action" && change.key !== "isConfirmed" && change.key !== "numGuests" && change.key !== "time";
        if (isDateKey) {
          const a = new Date(prev.value);
          const b = new Date(change.value);
          if (!isNaN(a) && !isNaN(b) && dateToShortString(a) === dateToShortString(b)) {
            return null;
          }
        } else if (prev.value === change.value) {
          return null;
        }
      }
      if (log.newState[index].key === "state") {
        return (
          <div style={{ display: "flex", gap: "5px" }}>
            <span className={logValueMap[log.newState[index].value].className}>
              {logValueMap[log.newState[index].value].value}
            </span>
          </div>
        );
      } else if (log.newState[index].key === "action") {
        const action = actionValueMap[log.newState[index].value];
        return (
          <div style={{ display: "flex", gap: "5px" }}>
            <span className={action?.className ?? "res-secondary"}>
              {action?.value ?? log.newState[index].value}
            </span>
          </div>
        );
      } else if (log.newState[index].key === "isConfirmed") {
        return (
          <div style={{ display: "flex", gap: "5px" }}>
            <span className="green-log">Confirmed via text</span>
          </div>
        );
      } else if (log.newState[index].key === "numGuests") {
        return (
          <div style={{ display: "flex", gap: "10px" }}>
            <span className="res-secondary res-log-secondary strike-through">
              {log.oldState[index].value}{" "}
              {log.newState[index].value > 1 ? "people" : "person"}{" "}
            </span>
            {" → "}
            <span className="gold-log">
              {log.newState[index].value}{" "}
              {log.newState[index].value > 1 ? "people" : "person"}{" "}
            </span>
          </div>
        );
      } else if (log.newState[index].key === "time") {
        return (
          <div style={{ display: "flex", gap: "10px" }}>
            <span className="res-secondary res-log-secondary strike-through">
              {convertTo12Hour(log.oldState[index].value)}
            </span>
            {" → "}
            <span className="gold-log">
              {convertTo12Hour(log.newState[index].value)}
            </span>
          </div>
        );
      } else {
        return (
          <div style={{ display: "flex", gap: "10px" }}>
            <span className="res-secondary res-log-secondary strike-through">
              {" "}
              {dateToShortString(new Date(log.oldState[index].value))}
            </span>
            {" → "}
            <span className="gold-log">
              {dateToShortString(new Date(log.newState[index].value))}
            </span>
          </div>
        );
      }
    };

    const renderFullLogChange = () => {
      const changes = [];
      for (let x = 0; x < log.newState.length; x++) {
        const rendered = renderSingleLogChange(x);
        if (rendered) changes.push(<div key={x}>{rendered}</div>);
      }
      return changes;
    };

    const textStatus = renderTextStatus();

    return (
      <div className="log-wrapper" key={index}>
        <div className="res-log-time">{friendlyDateTime(new Date(log.time))}</div>
        <div className="res-log">
          <span className="res-log-actor">
            {log.user ? log.user.charAt(0).toUpperCase() + log.user.slice(1) : "Customer"}
          </span>
          <div className="res-log-info">
            {renderFullLogChange()}
          </div>
          {textStatus && (
            <div className="res-log-footnote">{textStatus}</div>
          )}
        </div>
      </div>
    );
  };

  const history = res.history;

  const resBottom = () => {
    return (
      <div
        className={`bottom-wrapper bottom-wrapper-${isOpen} ${
          res.selfMade && "res-selfmade"
        }`}
      >
        <div className="res-bottom">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              minHeight: "100px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <span style={{ fontSize: "13px", opacity: 0.5, fontStyle: "italic" }}>
                  Booked {friendlyDateTime(new Date(res.dateMade))}
                </span>
                <span style={{ fontSize: "15px", opacity: 0.8 }}>
                  {res.phone && formatPhoneNumber(res.phone)}
                </span>
                <span style={{ fontSize: "15px", opacity: res.notes ? 0.7 : 0.35 }}>
                  {res.notes || "No notes"}
                </span>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "20px",
                alignItems: "flex-start",
              }}
            >
              {res.state !== "upcoming" && res.state !== "walkin" && undoButton()}
              {res.state === "upcoming" && cancelButton()}
              {res.state === "upcoming" && noShowButton()}
            </div>
          </div>
          <div className="res-history" style={{ paddingTop: "20px" }}>
            <div
              className="res-secondary"
              style={{ width: "100%", fontSize: "13px", fontStyle: "italic", opacity: 0.4 }}
            >
              Timeline
            </div>
            <div className="log-scroller">
              {isOpen && logs.map((log, index) => renderLog(log, index))}
            </div>
          </div>
          <div className="res-history" style={{ paddingTop: "20px" }}>
            <div
              className="res-secondary"
              style={{ width: "100%", fontSize: "13px", fontStyle: "italic", opacity: 0.4 }}
            >
              Customer History
            </div>
            {isOpen && (history ? (
              <CustomerHistory history={history} />
            ) : (
              <div
                className="res-log-info red-log"
                style={{ paddingTop: "10px" }}
              >
                {" "}
                Failed to load history{" "}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div key={res._id}>
      {resTop()}
      {resBottom()}
    </div>
  );
}

export const Reservation = memo(ReservationImpl);
export default Reservation;
